import styled from 'astroturf/react'
import SimpleBar from 'simplebar-react'
const colorTextStandard = 'var(--colorTextStandard, var(--coreColorNeutral900))'
const colorTextSecondary = 'var(--colorTextSecondary, var(--coreColorNeutral600))'
const colorStrokeStandard = 'var(--colorStrokeStandard, var(--coreColorNeutral400))'
const colorBackgroundStandard = 'var(--colorBackgroundStandard, var(--coreColorNeutral0))'
const colorBackgroundSecondary = 'var(--colorBackgroundSecondary, var(--coreColorNeutral100))'
const fontWeightBold = 'var(--fontWeightBold, 700)'
const fontSizeMedium = 'var(--fontSizeMedium, 0.875rem)'
const colorBackgroundWarning = 'var(--colorBackgroundWarning, var(--coreColorOrange200))'
const colorStrokeWarning = 'var(--colorStrokeWarning, var(--coreColorOrange600))'
import { BareButton } from '@calendly/ui/components/bare-button'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import _MutualAvailabilitySidebarWrapper from "styles-MutualAvailabilitySidebarWrapper.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/mutual_availability/styles.js?styleId=MutualAvailabilitySidebarWrapper";
import _Panel from "styles-Panel.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/mutual_availability/styles.js?styleId=Panel";
import _Avatar from "styles-Avatar.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/mutual_availability/styles.js?styleId=Avatar";
import _Header from "styles-Header.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/mutual_availability/styles.js?styleId=Header";
import _ClickableHeader from "styles-ClickableHeader.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/mutual_availability/styles.js?styleId=ClickableHeader";
import _InfoIconContainer from "styles-InfoIconContainer.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/mutual_availability/styles.js?styleId=InfoIconContainer";
import _Title from "styles-Title.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/mutual_availability/styles.js?styleId=Title";
import _CalendarsLine from "styles-CalendarsLine.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/mutual_availability/styles.js?styleId=CalendarsLine";
import _Content from "styles-Content.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/mutual_availability/styles.js?styleId=Content";
import _ScrollContainer from "styles-ScrollContainer.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/mutual_availability/styles.js?styleId=ScrollContainer";
import _EmptyMessage from "styles-EmptyMessage.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/mutual_availability/styles.js?styleId=EmptyMessage";
import _ErrorWarning from "styles-ErrorWarning.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/mutual_availability/styles.js?styleId=ErrorWarning";
import _PretendEventWarning from "styles-PretendEventWarning.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/mutual_availability/styles.js?styleId=PretendEventWarning";
import _Date from "styles-Date.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/mutual_availability/styles.js?styleId=Date";
import _RedesignHeader from "styles-RedesignHeader.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/mutual_availability/styles.js?styleId=RedesignHeader";
import _RedesignClickableHeader from "styles-RedesignClickableHeader.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/mutual_availability/styles.js?styleId=RedesignClickableHeader";
import _RedesignHeaderInner from "styles-RedesignHeaderInner.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/mutual_availability/styles.js?styleId=RedesignHeaderInner";
import _RedesignHeaderText from "styles-RedesignHeaderText.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/mutual_availability/styles.js?styleId=RedesignHeaderText";
import _RedesignTitle from "styles-RedesignTitle.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/mutual_availability/styles.js?styleId=RedesignTitle";
import _RedesignSubtitle from "styles-RedesignSubtitle.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/mutual_availability/styles.js?styleId=RedesignSubtitle";
import _RedesignHeaderActions from "styles-RedesignHeaderActions.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/mutual_availability/styles.js?styleId=RedesignHeaderActions";
import _RedesignAvatar from "styles-RedesignAvatar.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/mutual_availability/styles.js?styleId=RedesignAvatar";
import _RedesignFlexContent from "styles-RedesignFlexContent.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/mutual_availability/styles.js?styleId=RedesignFlexContent";
import _RedesignPhoneRoot from "styles-RedesignPhoneRoot.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/mutual_availability/styles.js?styleId=RedesignPhoneRoot";
import _RedesignPhoneHeader from "styles-RedesignPhoneHeader.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/mutual_availability/styles.js?styleId=RedesignPhoneHeader";
import _RedesignPhoneClickableHeader from "styles-RedesignPhoneClickableHeader.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/mutual_availability/styles.js?styleId=RedesignPhoneClickableHeader";


export const MutualAvailabilitySidebarWrapper = /*#__PURE__*/styled('div', null, {
  displayName: "MutualAvailabilitySidebarWrapper",
  styles: _MutualAvailabilitySidebarWrapper
})

export const Panel = /*#__PURE__*/styled('div', null, {
  displayName: "Panel",
  styles: _Panel
})

export const Avatar = /*#__PURE__*/styled('img', null, {
  displayName: "Avatar",
  styles: _Avatar
})

const headerHeight = '76px'

export const Header = /*#__PURE__*/styled('div', null, {
  displayName: "Header",
  styles: _Header
})

export const ClickableHeader = /*#__PURE__*/styled(Header, null, {
  displayName: "ClickableHeader",
  styles: _ClickableHeader,
  attrs: props => ({
    ...props,
    as: BareButton
  })
})

export const InfoIconContainer = /*#__PURE__*/styled('div', null, {
  displayName: "InfoIconContainer",
  styles: _InfoIconContainer
})

export const Title = /*#__PURE__*/styled('div', null, {
  displayName: "Title",
  styles: _Title
})

export const CalendarsLine = /*#__PURE__*/styled('div', null, {
  displayName: "CalendarsLine",
  styles: _CalendarsLine
})

export const Content = /*#__PURE__*/styled('div', null, {
  displayName: "Content",
  styles: _Content,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone')
  })
})

export const ScrollContainer = /*#__PURE__*/styled(SimpleBar, null, {
  displayName: "ScrollContainer",
  styles: _ScrollContainer
})

export const EmptyMessage = /*#__PURE__*/styled('div', null, {
  displayName: "EmptyMessage",
  styles: _EmptyMessage
})

export const ErrorWarning = /*#__PURE__*/styled('div', null, {
  displayName: "ErrorWarning",
  styles: _ErrorWarning
})

export const PretendEventWarning = /*#__PURE__*/styled('div', null, {
  displayName: "PretendEventWarning",
  styles: _PretendEventWarning
})

export const Date = /*#__PURE__*/styled('div', null, {
  displayName: "Date",
  styles: _Date
})

export const RedesignHeader = /*#__PURE__*/styled('div', null, {
  displayName: "RedesignHeader",
  styles: _RedesignHeader
})

export const RedesignClickableHeader = /*#__PURE__*/styled(BareButton, null, {
  displayName: "RedesignClickableHeader",
  styles: _RedesignClickableHeader
})

export const RedesignHeaderInner = /*#__PURE__*/styled('div', null, {
  displayName: "RedesignHeaderInner",
  styles: _RedesignHeaderInner
})

export const RedesignHeaderText = /*#__PURE__*/styled('div', null, {
  displayName: "RedesignHeaderText",
  styles: _RedesignHeaderText
})

export const RedesignTitle = /*#__PURE__*/styled('div', null, {
  displayName: "RedesignTitle",
  styles: _RedesignTitle
})

export const RedesignSubtitle = /*#__PURE__*/styled('div', null, {
  displayName: "RedesignSubtitle",
  styles: _RedesignSubtitle
})

export const RedesignHeaderActions = /*#__PURE__*/styled('div', null, {
  displayName: "RedesignHeaderActions",
  styles: _RedesignHeaderActions
})

export const RedesignAvatar = /*#__PURE__*/styled('img', null, {
  displayName: "RedesignAvatar",
  styles: _RedesignAvatar
})

export const RedesignFlexContent = /*#__PURE__*/styled('div', null, {
  displayName: "RedesignFlexContent",
  styles: _RedesignFlexContent
})

export const RedesignPhoneRoot = /*#__PURE__*/styled('div', null, {
  displayName: "RedesignPhoneRoot",
  styles: _RedesignPhoneRoot
})

export const RedesignPhoneHeader = /*#__PURE__*/styled('div', null, {
  displayName: "RedesignPhoneHeader",
  styles: _RedesignPhoneHeader
})

export const RedesignPhoneClickableHeader = /*#__PURE__*/styled(BareButton, null, {
  displayName: "RedesignPhoneClickableHeader",
  styles: _RedesignPhoneClickableHeader
})
